"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pxToRem = exports.SIZE_CONSTANT = void 0;
exports.SIZE_CONSTANT = 14;
var pxToRem = function (px, sizeConstaint) {
    if (sizeConstaint === void 0) { sizeConstaint = exports.SIZE_CONSTANT; }
    return ((px / sizeConstaint).toFixed(2) + "rem");
};
exports.pxToRem = pxToRem;
